import React from 'react'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../core/widgets'
import './VibeStudioPage.scss'

const VibeStudioPage = () => {
	return (
		<div className="main-content vibe-studio-page">
			<GamificationBlock
				domId={WIDGETS.vibeStudio.domId}
				url={WIDGETS.vibeStudio.url}
				fit="content"
				className="gamification-block--content"
			/>
		</div>
	)
}

export default VibeStudioPage
